<template>
    <div
        class="rubric-cell"
        :class="[selectedClass, editClass]"
        @click="selectCell()">
        <design2021-apprentice-display-html-component class="cell-content" :html-content="cellValue">
        </design2021-apprentice-display-html-component>

        <div
            class="selected-answers-user-credentials"
            v-if="canShowAnswersFromOtherUsers">
            <span
                class="user"
                v-for="answer in answersFromOtherUsersForColumn"
                v-b-tooltip.hover
                :class="`${getColorForUser(answer)}`"
                :key="rowIn.id + '-' + answer.id"
                :title="answer.user.full_name ? answer.user.full_name : null">
                {{ getUserInitials(answer.user) }}
            </span>
        </div>
    </div>
</template>

<script>
import Design2021ApprenticeDisplayHtmlComponent
    from '../../../common/design-2021-apprentice-display-html-component.vue';

export default {
    name: 'design-2021-rubric-form-column-cell-component',
    components: { Design2021ApprenticeDisplayHtmlComponent },
    props: {
        columnIn: Object,
        rowIn: Object,
        formIdIn: Number,
        edit: Boolean,
        showOtherResults: Boolean,
    },
    computed: {
        answersFromOtherUsersForColumn() {
            return this.rowIn.answers.filter(
                (answer) => answer.column_id === this.columnIn.id && answer.user_id !== this.$authUser.id,
            );
        },
        selectedClass() {
            if (this.rowIn.answers !== undefined) {
                for (const answer of this.rowIn.answers) {
                    if (this.columnIn.id === answer.column_id && answer.user_id === this.$authUser.id) {
                        return 'selected';
                    }
                }
            }
            return '';
        },
        editClass() {
            return this.edit ? '' : 'display-only';
        },
        cellValue() {
            const rowCell = this.columnIn.rubric_cells.find((rubricCell) => {
                return rubricCell.row_id === this.rowIn.id;
            });
            return rowCell ? rowCell.value : this.$t('rubrics.no_description_is_provided');
        },
        canShowAnswersFromOtherUsers() {
            if (!this.showOtherResults) {
                return false;
            }

            return this.rowIn.answers.some((answer) => {
                return answer.user_id !== this.$authUser.id && answer.column_id === this.columnIn.id;
            });
        },
    },
    methods: {
        getColorForUser(answer) {
            if (answer.user_id === this.$authUser.id) {
                return 'current-graph-bg-color';
            }

            switch (answer.user.type) {
                case 'teacher':
                    return 'teacher-graph-bg-color';
                case 'student':
                    return 'student-peer-graph-bg-color';
                default:
                    return 'default-peer-graph-bg-color';
            }
        },
        selectCell() {
            if (!this.edit) {
                return;
            }

            const answer = {
                column_id: this.columnIn.id,
                row_id: this.rowIn.id,
                rubric_form_id: this.formIdIn,
                user_id: this.$authUser.id,
            };

            this.$emit('cell-selected', answer);
        },

        getUserInitials(user) {
            let initials = '';
            if (user.name) {
                initials = user.name.slice(0, 1);
            }
            if (user.surname) {
                initials += user.surname.slice(0, 1);
            }
            return initials;
        },
    },
};
</script>

<style scoped lang="scss">
.rubric-cell {
    position: relative;
    padding: map-get($grid-gutter-spacing, 'fifteen');
    border: 2px solid transparent;
    background-color: rgba($secondary-background-color, 0.25);

    &:hover,
    &.selected {
        border-color: $primary;
    }

    &.display-only {
        cursor: default;
        border-color: transparent;

        &.selected {
            border-color: $primary;
        }
    }

    &:not(.display-only) {
        &:hover {
            cursor: pointer;
        }
    }
}

.cell-content {
    position: relative;
    margin-bottom: 45px;
}

.selected-answers-user-credentials {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    padding: map-get($grid-gutter-spacing, 'eight');
    border-top: 1px solid $border-color;
    height: 45px;
    width: 102%;
    right: 0;

    .user {
        display: flex;
        align-items: center;
        justify-content: center;
        //background-color: $primary;
        color: $white;
        font-size: $default-font-size;
        font-weight: $font-weight-medium;
        border-radius: 30px;
        height: 30px;
        width: 30px;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
